import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';

// Clears old cached app files and reloads the newest version.
// Does NOT touch localStorage (login, approved device, offline bill queue stay safe).
export async function hardReload() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if (window.caches) {
      const keys = await window.caches.keys();
      await Promise.all(keys.map((k) => window.caches.delete(k)));
    }
  } catch (e) { /* ignore */ }
  const u = new URL(window.location.href);
  u.searchParams.set('v', String(Date.now()));
  window.location.replace(u.toString());
}

const currentMain = () => {
  const s = [...document.querySelectorAll('script[src]')].map((x) => x.getAttribute('src')).find((src) => /\/static\/js\/main\.[^/]+\.js/.test(src));
  return s ? s.replace(/^https?:\/\/[^/]+/, '') : null;
};

function UpdateBanner() {
  const [hasUpdate, setHasUpdate] = useState(false);
  const [busy, setBusy] = useState(false);
  const isPhone = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 900px)').matches;

  useEffect(() => {
    const mine = currentMain();
    if (!mine) return undefined;
    const check = () => fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((m) => { const latest = m && m.files && m.files['main.js']; if (latest && latest !== mine) setHasUpdate(true); })
      .catch(() => {});
    check();
    const t = setInterval(check, 120000);
    const onVis = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVis);
    window.addEventListener('focus', check);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', onVis); window.removeEventListener('focus', check); };
  }, []);

  const go = () => { setBusy(true); hardReload(); };

  return (
    <>
      {hasUpdate && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 6000, display: 'flex', justifyContent: 'center', padding: 8, pointerEvents: 'none' }}>
          <button type="button" onClick={go} disabled={busy}
            style={{ pointerEvents: 'auto', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 18px', borderRadius: 999, border: 0,
              background: '#6948dc', color: '#fff', fontWeight: 800, fontSize: 15, cursor: 'pointer', boxShadow: '0 10px 30px rgba(105,72,220,.4)', font: 'inherit' }}>
            🔄 {busy ? 'Updating…' : 'New update available · Tap to update'}
          </button>
        </div>
      )}
      {isPhone && (
        <button type="button" onClick={go} disabled={busy} title="Update the app"
          style={{ position: 'fixed', left: 12, bottom: 'calc(12px + env(safe-area-inset-bottom))', zIndex: 5500, height: 40, padding: '0 14px',
            borderRadius: 999, border: '1px solid #e2dcea', background: 'rgba(255,255,255,.95)', color: '#5b3fd9', fontWeight: 800, fontSize: 13,
            boxShadow: '0 6px 18px rgba(35,26,51,.15)', cursor: 'pointer', font: 'inherit' }}>
          {busy ? '⟳ …' : '⟳ Update'}
        </button>
      )}
    </>
  );
}

export function mountUpdateBanner() {
  if (document.getElementById('update-banner-root')) return;
  const el = document.createElement('div'); el.id = 'update-banner-root'; document.body.appendChild(el);
  createRoot(el).render(<UpdateBanner />);
}
